<div ngbDropdown [autoClose]="true" #dotDropdown="ngbDropdown" container="body" class="ssc-title-options">
  <div ngbDropdownToggle>
    <app-icon-more-dot size="18" [color]="color"></app-icon-more-dot>
  </div>
  <div ngbDropdownMenu class="dropdown-orderby" (click)="$event.stopPropagation(); dotDropdown.close()">
    <ng-content select=".dropdown-menu-content"></ng-content>
  </div>
</div>
